(function() {
    'use strict';

    Directives.OnboardingOverviewCardDirective = function OnboardingOverviewCardDirective() {

        // @ngInject
        function OnboardingOverviewCardDirectiveControllerCtor($scope, $injector,
                                                               Constants) {
            this.constructor.$super.call(this, $scope, $injector);
            this.__objectType = 'OnboardingOverviewCardDirectiveController';
            this.Constants = Constants;
        }

        var OnboardingOverviewCardDirectiveController = Class(Controllers.BaseController, {
            constructor: OnboardingOverviewCardDirectiveControllerCtor,

            isComplete: function isComplete(){
                return this.state !== null && (this.state === this.Constants.OnboardingOverviewStates.COMPLETE);
            }
        });

        return {
            scope: {
                contentTitle: '@contentTitle',
                contentDescription: '@contentDescription',
                buttonText: '@buttonText',
                buttonOnClick: '=buttonOnClick',
                buttonAnalyticsEvent: '@buttonAnalyticsEvent',
                buttonAnalyticsProperty: '@buttonAnalyticsProperty',
                contentIcon: '@contentIcon',
                state: '=state',
            },
            templateUrl: 'angular/app/modules/core/features/onboarding/onboarding_overview/onboarding_overview_card_template.html',
            controller: OnboardingOverviewCardDirectiveController,
            controllerAs: 'onboardingCardVm',
            bindToController: true,
        };
    };

}());